import React from 'react';
import { Link } from '@mui/material';
import { DisclaimerText } from './styled';

const DisclaimerFooter = ({
  footerText,
  footerLinks
}: {
  footerText: string;
  footerLinks: { label: string; onClick: () => void }[];
}) => (
  <DisclaimerText>
    {footerText}{' '}
    {footerLinks.map((link, index) => (
      <React.Fragment key={index}>
        <Link
          component='button'
          onClick={link.onClick}
          sx={{ cursor: 'pointer' }}
        >
          {link.label}
        </Link>
        {index < footerLinks.length - 1 ? ' & ' : ''}
      </React.Fragment>
    ))}
  </DisclaimerText>
);

export default DisclaimerFooter;
